import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const Camera: React.FunctionComponent<SvgIconProps> = ({ ...props }) => (
    <SvgIcon {...props} width="32px" height="32px" viewBox="0 0 32 32" version="1.1">
        <g id="Style-Guide" stroke="none" strokeWidth="1" fill="inherit" fillRule="evenodd">
            <g transform="translate(-624.000000, -2276.000000)" id="Icons">
                <g transform="translate(48.000000, 2212.000000)">
                    <g id="Camera-Icon" transform="translate(576.000000, 64.000000)">
                        <g id="1.-Icon/Camera/Active">
                            <path
                                d="M17.8521,8.3 C19.0701,8.3 20.0661,9.45 20.0661,10.856 L20.0661,10.856 L20.0661,21.112 C20.0661,22.518 19.0701,23.668 17.8521,23.668 L17.8521,23.668 L6.2141,23.668 C4.9971,23.668 3.9991,22.518 3.9991,21.112 L3.9991,21.112 L3.9991,10.856 C3.9991,9.45 4.9971,8.3 6.2141,8.3 L6.2141,8.3 Z M26.6958,9.1486 C27.1878,8.6806 28.0008,8.8716 28.0008,9.5506 L28.0008,9.5506 L28.0008,22.4176 C28.0008,23.0956 27.1878,23.2866 26.6958,22.8196 L26.6958,22.8196 L21.7308,17.8476 L21.7308,14.1206 Z"
                                id="Combined-Shape"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </SvgIcon>
);
export default Camera;
